import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import AdminUsers from '../../../../containers/Admin/Users';
import ProfileEdit from '../../../../containers/ProfileEdit';

const SettingsUsersContent = (props) => {
  const { activeSubTab } = props;
  const { userUuid } = useParams();

  if (!activeSubTab && !userUuid) return <AdminUsers />;

  if (activeSubTab === 'add' || userUuid) return <ProfileEdit />;

  return null;
};

SettingsUsersContent.propTypes = {
  activeSubTab: PropTypes.string,
};

SettingsUsersContent.defaultProps = {
  activeSubTab: null,
};

export default SettingsUsersContent;
